import React from 'react';
import Box from 'js/components/box/box';
import Button from 'js/components/button/button';
import Col from 'js/components/grid/column';
import Row from 'js/components/grid/row';
import Label from 'js/components/label/label';
import SectionTitle from 'js/components/section-title/section-title';
import Text from 'js/components/text/text';
import IntegrationButton from './integration-button';
import { HELP_EMAIL, MAIN_INTEGRATIONS } from '../constants';
import steps from '../enums/steps.enum';
import styles from '../quick-start.module.scss';

const SummaryStep = ({ integrations, onStepChange }) => {
    const mainIntegrations = MAIN_INTEGRATIONS.map(({ name, helpUrl }) => ({
        ...integrations.find(
            (item) => item.name.toLowerCase() === name.toLowerCase(),
        ),
        helpUrl,
    })).filter((item) => item.id && item.helpUrl);

    return (
        <>
            <SectionTitle>All set! Your context is ready</SectionTitle>
            <Box margin={['small', 0, 'large']}>
                <Text size="base" color={['gray', 'dark']}>
                    Keep an eye on your inbox – targeting details are on the
                    way.
                </Text>
            </Box>

            <Label
                label="Helpful Guides"
                hint={
                    <p>
                        New to targeting in the DSP? Our step-by-step guides can
                        help.
                    </p>
                }
            >
                <Row gap="base">
                    {mainIntegrations.map(({ name, logo, helpUrl }) => (
                        <Col span={12} spanMd={4} spanSm={6}>
                            <IntegrationButton
                                label={name}
                                logo={logo}
                                onClick={() => {
                                    window.open(helpUrl, '_blank');
                                }}
                            />
                        </Col>
                    ))}
                </Row>
            </Label>

            <Box
                margin={['large', 0]}
                padding="base"
                background={['aqua', 'lightest']}
                borderRadius="round"
            >
                <Text size="larger">
                    <Text inline weight="bolder">
                        Need help?
                    </Text>{' '}
                    Our account managers have you covered
                </Text>
                <Box margin={['small', 0, 0]}>
                    <Text weight="bold">
                        Contact us at{' '}
                        <a
                            className={styles.link}
                            href={`mailto:${HELP_EMAIL}`}
                        >
                            {HELP_EMAIL}
                        </a>
                    </Text>
                </Box>
            </Box>

            <Box margin={['large', 0, 0]}>
                <div className={styles['wizard-buttons']}>
                    <Button onClick={() => onStepChange(steps.DETAILS)}>
                        Build Another Context
                    </Button>
                </div>
            </Box>
        </>
    );
};

export default SummaryStep;
